import store from '../store/store';
import { getMailboxForwardingConfiguration } from 'owa-forwarding-configuration';
import { getFallbackValueIfNull } from 'owa-options-core';

/**
 * Returns the current value of what's in the forwarding email address input
 * box.
 * @returns The value of the input box
 */
export default function getForwardingEmailAddress(): string {
    const forwardingConfiguration = getMailboxForwardingConfiguration();
    const optionState = store;

    return getFallbackValueIfNull(
        optionState.forwardingEmailAddress,
        forwardingConfiguration.AddressString
    );
}
